import { TZB_URL, NAV_LINKS } from "appLauncher";
import { useState, useEffect } from "react";
import styled from "styled-components";

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 84px;
  border-bottom: 0.5px #2640ed36 solid;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  justify-content: space-between;
`;

const NavGroup = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.div`
  width: 101px;
  height: 31px;
  background-image: url(/assets/logo.jpg);
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2640ed;
  font-size: 28px;
  font-weight: 600;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  margin-left: 100px;
  @media (max-width: 900px) {
    display: none;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: 48px;
  color: #2640ed;
  cursor: pointer;
  margin-right: 24px;
  @media (max-width: 900px) {
    display: block;
  }
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 84px;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 999;
  display: flex;
  flex-direction: column;
  padding: 16px 32px;
  border-top: 1px solid #eef;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s;
  &.show {
    max-height: 400px;
    opacity: 1;
  }
`;

interface NavLinkProps {
  $active?: boolean;
}
const NavLink = styled.a<NavLinkProps>`
  margin: 0 30px;
  color: ${({ $active }) => ($active ? "#004CFF" : "#656565")};
  text-decoration: none;
  font-size: 16px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  transition: color 0.2s;
  position: relative;
  &:hover {
    color: #004cff;
  }
`;

const LoginButton = styled.button`
  padding: 8px 24px;
  background: #2640ed;
  color: #fff;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.2s;
  &:hover {
    background: #1b2e99;
  }
`;

export default function Header() {
  const [activePath, setActivePath] = useState(
    typeof window !== "undefined" ? window.location.pathname : "/"
  );
  const [menuOpen, setMenuOpen] = useState(false);

  // 页面宽度变化时关闭下拉菜单
  useEffect(() => {
    function handleResize() {
      setMenuOpen(false);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = (href: string) => {
    if (!href.startsWith("http")) setActivePath(href);
    setMenuOpen(false);
  };

  return (
    <HeaderWrapper>
      <Content>
        <NavGroup>
          <MenuButton onClick={() => setMenuOpen((v) => !v)}>
            <span>☰</span>
            {/* <span
              style={{
                marginLeft: 8,
                color: "#2640ed",
                fontWeight: 600,
                fontSize: 16,
              }}
            >
              {NAV_LINKS.find((l) => l.href === activePath)?.label}
            </span> */}
          </MenuButton>
          <Logo></Logo>
          <Nav>
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.href}
                href={link.href}
                target={link.href.startsWith("http") ? "_blank" : "_self"}
                $active={activePath === link.href}
                onClick={() => handleNavClick(link.href)}
              >
                {link.label}
              </NavLink>
            ))}
          </Nav>
        </NavGroup>
        <LoginButton onClick={() => window.open(TZB_URL, "_blank")}>
          登录/注册
        </LoginButton>
        <DropdownMenu className={menuOpen ? "show" : ""}>
          {menuOpen &&
            NAV_LINKS.map((link) => (
              <NavLink
                key={link.href}
                href={link.href}
                $active={activePath === link.href}
                onClick={() => handleNavClick(link.href)}
                style={{ margin: "12px 0", fontSize: 18 }}
              >
                {link.label}
              </NavLink>
            ))}
        </DropdownMenu>
      </Content>
    </HeaderWrapper>
  );
}
